import { Block, helpers as contentfulHelpers, Inline, Text } from '@contentful/rich-text-types';
import React, { Children, HTMLAttributes } from 'react';

export const getHtmlElementWithProps = (
    node: Block | Inline,
    children: React.ReactNode,
    props?: HTMLAttributes<HTMLElement>
): { child: React.ReactNode; props?: HTMLAttributes<HTMLElement> } => {
    const newProps = props || {};
    const anchorTag = tryGetAnchorTagData(node);
    if (anchorTag) {
        newProps.id = anchorTag.anchorId;
        children = anchorTag.anchorText ? anchorTag.anchorText : Children.toArray(children).slice(1);
    }
    return {
        props: newProps,
        child: children,
    };
};

const tryGetAnchorTagData = (node: Inline | Block): { anchorId: string; anchorText?: string } | undefined => {
    if (node.content.length === 0) return;

    const firstContent = node.content[0];
    if (!contentfulHelpers.isText(firstContent)) return;

    const { value } = firstContent as Text;
    if (!value || !value.startsWith('{#')) return;

    const closingBracket = value.indexOf('}');

    const anchorId = value.substring(2, closingBracket);
    const anchorText = value.substring(closingBracket + 1);
    return {
        anchorId,
        anchorText,
    };
};
